import { EChatActionTypes } from '../../actions/chat';
import { IChat } from '../../types/chat';
import { TReduxActions } from '../../types/redux';

export const defaultState: IChat = {
  isOpen: false,
  offer: null,
  position: null,
  defaultMessage: undefined,
};

export function chatReducer(state: IChat = defaultState, action: TReduxActions): IChat {
  switch (action.type) {
    case EChatActionTypes.Open: {
      return {
        ...state,
        isOpen: true,
        ...action.payload,
      };
    }

    case EChatActionTypes.Close: {
      return {
        ...state,
        isOpen: false,
        offer: null,
        position: null,
        defaultMessage: undefined,
      };
    }
  }

  return state;
}
